module.exports = __webpack_public_path__ + "img/new_36.1c6ee890.jpg";